// Utility functions for pipeline operations

export const getStepStatus = (stepIndex, stepResults, stepErrors) => {
  if (stepErrors && stepErrors[stepIndex]) return 'error';
  if (stepResults && stepResults[stepIndex]) return 'completed';
  return 'pending';
};

export const getStepVariant = (status) => {
  switch (status) {
    case 'completed': return 'success';
    case 'processing': return 'warning';
    case 'current': return 'primary';
    case 'error': return 'danger';
    default: return 'light';
  }
};

export const calculateProgressPercentage = (stepResults, totalSteps) => {
  const completedSteps = Object.keys(stepResults || {}).length;
  return (completedSteps / totalSteps) * 100;
};

export const formatApiError = (error) => {
  let errorMessage = 'Unknown error occurred';
  
  if (error.response) {
    // HTTP error response
    if (error.response.data && error.response.data.detail) {
      if (Array.isArray(error.response.data.detail)) {
        // Handle validation errors
        errorMessage = error.response.data.detail.map(err => `${err.loc?.join('.')}: ${err.msg}`).join(', ');
      } else if (typeof error.response.data.detail === 'string') {
        errorMessage = error.response.data.detail;
      } else {
        errorMessage = JSON.stringify(error.response.data.detail);
      }
    } else if (error.response.data && typeof error.response.data === 'string') {
      errorMessage = error.response.data;
    } else if (error.response.data) {
      errorMessage = JSON.stringify(error.response.data);
    } else {
      errorMessage = `HTTP ${error.response.status}: ${error.response.statusText}`;
    }
  } else if (error.message) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    errorMessage = JSON.stringify(error);
  }
  
  return errorMessage;
};
